import Vue from 'vue';

import { Circuit } from '@/models/purchase-condition/circuit-enum';
import I18n from '@/plugins/i18n';
import { getPurchaseConditions } from '@/resources/apollo/queries/purchase-conditions';
import { generateCsvContent } from '@/services/csv-generator';
import { getIsoFormattedDate } from '@/services/date-formater';
import { transformPurchaseConditionToCsvLine } from '@/services/purchase-conditions';
import {
  PurchaseConditionsActiveFilters,
  PurchaseConditionsFilters,
  SettableFilters
} from '@/modules/purchase-conditions/definitions';

export * from '@/modules/purchase-conditions/definitions';

const circuitNames = [Circuit.DIRECT, Circuit.WAREHOUSE, Circuit.CROSSDOCK, Circuit.LDD];
const circuits = circuitNames.map(circuitName => {
  return {
    label: I18n.t(`headers.circuits.${circuitName}`) as string,
    value: circuitName,
    selected: false
  };
});

export const purchaseConditionsFilters = Vue.observable<PurchaseConditionsFilters>({
  from: undefined,
  to: new Date().toISOString(),
  circuits,
  supplierCode: undefined,
  supplierCorpName: undefined
});

function getActiveFilters(): PurchaseConditionsActiveFilters {
  const { from, to, supplierCode, supplierCorpName } = purchaseConditionsFilters;
  const activeFilters: PurchaseConditionsActiveFilters = { from, to, supplierCode, supplierCorpName };

  const circuits = purchaseConditionsFilters.circuits.filter(circuit => circuit.selected);
  if (circuits.length > 0) {
    activeFilters.circuits = circuits.map(circuit => circuit.value);
  }

  return activeFilters;
}

export function setFilter(filter: 'from' | 'supplierCorpName', value?: string): void;
export function setFilter(filter: 'to', value: string): void;
export function setFilter(filter: 'supplierCode', value?: number): void;
export function setFilter(filter: SettableFilters, value: PurchaseConditionsFilters[SettableFilters]): void {
  Vue.set(purchaseConditionsFilters, filter, value);
}

export function toggleCircuitFilter(index: number): void {
  const selected = !purchaseConditionsFilters.circuits[index].selected;
  const circuitFilter = { ...purchaseConditionsFilters.circuits[index], selected };
  Vue.set(purchaseConditionsFilters.circuits, index, circuitFilter);
}

export async function queryAndFormatPurchaseConditionsToCsv(): Promise<string | null> {
  const csvHeaders = I18n.t('page.consultation.export.csvHeaders') as string;

  const filters = getActiveFilters();
  const dateValue = new Date(filters.to);
  const nextDayDate = new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate() + 1);
  filters.to = getIsoFormattedDate(nextDayDate);

  const purchaseConditions = await getPurchaseConditions(filters);
  let csvContent = null;
  if (purchaseConditions.length > 0) {
    csvContent = generateCsvContent(csvHeaders, purchaseConditions, transformPurchaseConditionToCsvLine);
  }
  return csvContent;
}
